<template>
  <section>
    <img src="../assets/img/logo.svg" alt="Logo of ViaBus" id="viabus-logo" />
    <h1>ViaBus</h1>

    <!-- <div>{{ os }}</div> -->

    <button id="open-app-button" @click="openApp">{{ OPEN_APP }}</button>

    <h2>{{ DONT_HAVE_APP }}</h2>

    <div style="display: flex">
      <DownloadButton id="download-button" :os="os" :lang="lang" />
      <DownloadButton
        v-if="os.toLowerCase() == 'android'"
        style="margin-left: 8px"
        id="download-button"
        :os="'huawei'"
        :lang="lang"
      />
    </div>
  </section>
</template>

<script>
import DownloadButton from '../components/download-button';
import { DONT_HAVE_APP, OPEN_APP } from '../utils/translations';
import { getMobileOperatingSystem } from '../utils/useragent';
// import { GOOGLE_PLAY_LINK } from '../utils/links';

export default {
  components: {
    DownloadButton,
  },
  computed: {
    DONT_HAVE_APP() {
      return DONT_HAVE_APP[this.lang];
    },
    OPEN_APP() {
      return OPEN_APP[this.lang];
    },
    lang() {
      if (this.$route.query.lang) return this.$route.query.lang.toUpperCase();
      return 'TH';
    },
    os() {
      if (this.$route.query.os) return this.$route.query.os.toLowerCase();
      // eslint-disable-next-line
      if (getMobileOperatingSystem()) return getMobileOperatingSystem().toLowerCase();
      return 'ios';
    },
  },
  data() {
    return {};
  },
  methods: {
    openApp() {
      const url = new URL(window.location.href);

      let path = url.pathname.replace(/^\/m\/d\/l/, '');
      if (path === '/') path = '';
      const deepLink = `co.viabus://link${path}${url.search}${url.hash}`;
      location.href = deepLink;
    },
  },
  mounted() {
    // Call openApp() automatically for Android.
    if (this.os.toLowerCase() == 'android') {
      const now = new Date().getTime();
      // Open Google Play directly.
      const fallbackUrl = `market://details?id=com.indyzalab.transitia`;
      this.openApp();
      setTimeout(() => {
        if (new Date().getTime() - now < 2000) {
          location.href = fallbackUrl;
        }
      }, 1500);
    }
  },
};
</script>

<style lang="scss" scoped>
section {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
}

h1 {
  color: #263373;
  font-family: Arial, Helvetica, sans-serif;
  font-size: calc(var(--base-size) * 24);
  font-weight: 500;
  margin: calc(var(--base-size) * 10) 0 0;
}

h2 {
  color: #7a88b8;
  font-family: Arial, Helvetica, sans-serif;
  font-size: calc(var(--base-size) * 16);
  font-weight: 500;
  margin: calc(var(--base-size) * 32) 0 0;
}

#download-button {
  margin: calc(var(--base-size) * 12) 0 0;
}

#open-app-button {
  background: #4d6aff;
  border: none;
  border-radius: calc(var(--base-size) * 8);
  color: #fff;
  font-size: calc(var(--base-size) * 16);
  font-weight: 500;
  height: calc(var(--base-size) * 48);
  margin-top: calc(var(--base-size) * 64);
  width: calc(var(--base-size) * 288);

  &:hover {
    cursor: pointer;
  }

  &:active {
    padding: 0;
  }
}

#viabus-logo {
  width: calc(var(--base-size) * 128);
  margin-top: 16vh;
}
</style>
